(() => {
  const start = () => {
  const layer = document.querySelector('.aaronya-autumn-leaves');
  if (!layer) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || document.hidden) {
    layer.remove();
    return;
  }
  const smallScreen = window.matchMedia('(max-width: 749px)').matches;
  const count = smallScreen ? 6 : 12;
  const collectionPage = document.body.classList.contains('october-collection');
  const colors = ['#ac4b20', '#cf812b', '#935134', '#ba6427'];
  const shapes = [
    '<path d="M31 57 29 43 16 46 19 36 7 30 18 26 14 16 25 20 31 4 37 20 48 16 44 26 55 30 43 36 46 46 33 43 34 57Z" fill="currentColor"/><path d="M31 49V16M31 34 20 27M31 34 42 27M31 42 22 38M31 42 40 38" fill="none" stroke="#fff0d2" stroke-opacity=".4" stroke-width="1.1"/>',
    '<path d="M31 54C10 45 11 22 33 6 53 24 53 43 31 54Z" fill="currentColor"/><path d="M30 59 33 15M32 31 22 24M31 39 43 31M31 46 21 38" fill="none" stroke="#fff0d2" stroke-opacity=".4" stroke-width="1.1"/>'
  ];
  for (let i = 0; i < count; i++) {
    const leaf = document.createElement('span');
    leaf.className = 'aaronya-autumn-leaf';
    leaf.style.setProperty('--leaf-left', `${(i + .2 + Math.random() * .6) / count * 100}%`);
    leaf.style.setProperty('--leaf-size', `${(smallScreen ? 21 : 25) + Math.random() * 12}px`);
    leaf.style.setProperty('--leaf-duration', `${5.2 + Math.random() * 1.4}s`);
    leaf.style.setProperty('--leaf-delay', `${collectionPage ? -(.8 + Math.random() * 2.2) : Math.random() * 1.2}s`);
    leaf.style.setProperty('--leaf-drift', `${(Math.random() - .5) * (smallScreen ? 95 : 180)}px`);
    leaf.style.setProperty('--leaf-angle', `${Math.random() * 180}deg`);
    leaf.style.setProperty('--leaf-turn', `${1.7 + Math.random() * 1.2}s`);
    leaf.style.setProperty('--leaf-color', colors[i % colors.length]);
    leaf.innerHTML = `<svg viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg" focusable="false">${shapes[i % shapes.length]}</svg>`;
    layer.append(leaf);
  }
  const finish = () => {
    layer.remove();
    window.clearTimeout(timer);
    window.removeEventListener('pagehide', finish);
    document.removeEventListener('visibilitychange', visibility);
    reducedMotion.removeEventListener('change', finish);
  };
  const visibility = () => {
    if (document.hidden) finish();
  };
  const timer = window.setTimeout(finish, 8200);
  window.addEventListener('pagehide', finish, { once: true });
  document.addEventListener('visibilitychange', visibility);
  reducedMotion.addEventListener('change', finish, { once: true });
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
